"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const Outlook = createSVGIcon(
  <>
    <path d="M13.678 1.263 1.263 3.433v16.464l12.415 2.154z" fill="#333" />
    <path
      d="M13.678 6.173h6.532c.697 0 1.263.565 1.263 1.263v8.156c0 .698-.566 1.263-1.263 1.263h-6.532"
      stroke="currentColor"
    />
    <path d="m21.473 6.173-5.327 5.197-3.029-3.03" stroke="currentColor" />
    <path
      d="M9.582 11.367c0 1.857-1.194 3.122-2.4 3.122s-2.4-1.265-2.4-3.122 1.194-3.122 2.4-3.122 2.4 1.265 2.4 3.122Z"
      stroke="#fff"
    />
  </>,
  "Outlook",
  { viewBox: "0 0 24 24", fill: "none", className: legacyIconCls() } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
